import styled from 'styled-components'

const PricePlanActionTitleUi = styled.div`
  font-size: 22px;
  color: #000033;
`

export default PricePlanActionTitleUi
